import React from 'react'

const WorksItems = ({ item }) => {
  return (
    <div className="work__card">
      <img src={item.image} alt="Project preview" className="work__img" />
      <h3 className="work__tittle">{item.tittle}</h3>
      <p className="work__description">{item.description}</p>
      <a href={item.url} className="work__button" target="_blank" rel="noopener noreferrer">
        GitHub Repo
        <i className="bx bx-right-arrow-alt work__button-icon"></i>
      </a>
    </div>
  )
}

export default WorksItems;
